import { render, staticRenderFns } from "./OverlayLink.vue?vue&type=template&id=64d5f85a&"
import script from "./OverlayLink.vue?vue&type=script&lang=ts&"
export * from "./OverlayLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports